<script setup lang="ts">
import { ref } from 'vue'

import { Button, Popover } from '@collector/shared-ui'

import { buttonClass } from '../consts'
import StatusesPopoverContent from './StatusesPopoverContent.vue'

// state
const isPopoverOpen = ref(false)
</script>

<template>
  <Popover
    v-model="isPopoverOpen"
    :content="{
      class: '@sm:ml-10',
      align: 'start',
    }"
    :arrow="{
      class: '@sm:mr-8',
    }"
    :trigger="{
      asChild: true,
    }"
  >
    <template #trigger>
      <Button
        :class="[
          {
            'bg-neutral-light-0! border-neutral-light-0!': isPopoverOpen,
          },
          buttonClass,
        ]"
        icon="stopwatch"
        size="sm"
        iconSize="sm"
      >
        <span class="@max-sm:hidden">Statuses</span>
      </Button>
    </template>
    <template #content>
      <StatusesPopoverContent
        class="w-56 @sm:w-[21.75rem]"
        @click="isPopoverOpen = false"
      />
    </template>
  </Popover>
</template>
